// Unpublished Work © 2023-2024 Deere & Company.

/* eslint-disable react/prop-types */
import { createContext, useState } from "react";

const initialData = {
  currentSelectedNavigationItemIndex: -1,
  previousSelectedNavigationItemIndex: -1,
};

interface GenericSharedStateManager<T> {
  setState: (data: T) => void;
  state: T;
}

type SharedStateData = typeof initialData;
type SharedStateManager = GenericSharedStateManager<SharedStateData>;

export const SharedStateManagerContext = createContext<SharedStateManager>({
  setState: () => {},
  state: initialData,
});

export const SharedState = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const [sharedState, setSharedState] = useState<SharedStateData>(initialData);

  const sharedStateManager: SharedStateManager = {
    setState: setSharedState,
    state: sharedState,
  };

  return (
    <>
      <SharedStateManagerContext.Provider value={sharedStateManager}>
        {children}
      </SharedStateManagerContext.Provider>
    </>
  );
};
